const r=18===new Uint8Array(new Uint32Array([305419896]).buffer)[0],t=(r,t,e)=>{let n=r[t];r[t]=r[e],r[e]=n};var e={swap32LE:e=>{r&&(r=>{const e=r.length;for(let n=0;n<e;n+=4)t(r,n,n+3),t(r,n+1,n+2)})(e)}};export{e as s};
//# sourceMappingURL=swap.mjs.map
